export const filesQueryKeys = {
	all: ["files"] as const,
	fileUrls: () => [...filesQueryKeys.all, "file-urls"] as const,
	fileUrlByBucketAndKey: (bucket?: string, key?: string) =>
		[...filesQueryKeys.fileUrls(), "bucket-and-key", bucket, key] as const,
	signedUrls: () => [...filesQueryKeys.all, "signed-urls"] as const,
	signedPutUrl: (bucket: string, contentType?: string) =>
		[...filesQueryKeys.signedUrls(), "put", bucket, contentType] as const,
	signedGetUrl: (key: string) =>
		[...filesQueryKeys.signedUrls(), "get", key] as const,
	details: () => [...filesQueryKeys.all, "details"] as const,
	fileWithMetadata: (id: string) =>
		[...filesQueryKeys.details(), "metadata", id] as const,
	filesWithMetadata: (ids: string[]) =>
		[
			...filesQueryKeys.details(),
			"metadata-batch",
			...ids.sort((a, b) => a.localeCompare(b)),
		] as const,
	fileMetadataDetails: (id: string) =>
		[...filesQueryKeys.fileWithMetadata(id), "metadata-details", id] as const,
	folderHasAiJobRunning: (folderId: string) =>
		[...filesQueryKeys.all, "folder-has-ai-job-running", folderId] as const,
};
